import AddUserFrom from "components/user/AddUserFrom";
import React from "react";

function AddUser() {
  return (
    <div className="content">
      <AddUserFrom />
    </div>
  );
}

export default AddUser;
